import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraMetricStrip } from '../captains/metric-strip';
import { PADDING } from './page-padding';
const RAIL = {
    // unchanged from the pre-EXT-7 aside
    default: 'border-t border-border bg-background lg:border-l lg:border-t-0',
    // mockup .rl: sand surface, flush right, only as tall as its content, rounded bottom-left
    record: 'min-w-0 border-t border-border bg-[color:var(--surface-rail)] lg:self-start lg:rounded-bl-[var(--radius-rail)] lg:border-t-0'
};
/** Overview layout with header, KPI region, work column, and briefing rail. */ export const SpecraDashboardPage = /*#__PURE__*/ React.forwardRef(({ children, className, header, metrics, padding = 'default', rail, railLabel = 'Details', railVariant = 'default', workMaxWidth = 'none', ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: cn(// The rail column exists only when there is a rail; otherwise the work
        // column takes the full width.
        'grid min-h-full', rail && 'lg:grid-cols-[minmax(0,1fr)_var(--component-briefing-rail-width)]', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cn('min-w-0 space-y-5 sm:space-y-6', PADDING[padding], workMaxWidth === 'column' && 'w-full max-w-[var(--component-work-column-width)]'),
                children: [
                    header,
                    metrics ? /*#__PURE__*/ _jsx(SpecraMetricStrip, {
                        ...metrics
                    }) : null,
                    children
                ]
            }),
            rail ? /*#__PURE__*/ _jsx("aside", {
                "aria-label": railLabel,
                className: RAIL[railVariant],
                children: rail
            }) : null
        ]
    }));
SpecraDashboardPage.displayName = 'SpecraDashboardPage';
